import { grey } from "@mui/material/colors";

const styles = {
  mobileNavigation: (discoverTabOpen: boolean) => ({
    display: "flex",
    alignItems: "center",
    pl: discoverTabOpen ? 2 : 0,
    pr: 2,
    ml: { xs: 0, md: "60px" },
    height: 60,
    borderBottom: "none",
  }),
  navigation: {
    position: "fixed",
    display: "flex",
    alignItems: "center",
    pl: 2,
    pr: 4,
    left: 80,
    right: 0,
    height: 60,
    borderBottom: "1px solid #E5DCC8",
  },
  menuButton: {
    fontSize: { xs: 12, md: 14 },
    px: 2,
  },
  activeMenuButton: {
    backgroundColor: "green.main",
    color: "white",
    "&:hover": {
      backgroundColor: "green.light",
    },
  },
  avatar: {
    backgroundColor: "#0E3A2A",
    color: "white",
    fontSize: { xs: 13, md: 14 },
    fontWeight: 700,
    width: { xs: 34, md: 38 },
    height: { xs: 34, md: 38 },
  },
  planChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    borderRadius: 9999,
    textTransform: "none",
    backgroundColor: "#fff",
    border: "1px solid #E5DCC8",
    color: "#1F5040",
    fontSize: 12.5,
    fontWeight: 500,
    pl: 1.5,
    pr: 0.75,
    py: 0.5,
    "& strong": {
      color: "#0E3A2A",
      fontWeight: 600,
    },
    "&:hover": {
      backgroundColor: "#F4F0E7",
      borderColor: "#D8CCB2",
    },
  },
  upgradeLink: {
    backgroundColor: "#0E3A2A",
    color: "#fff",
    borderRadius: 9999,
    fontSize: 11.5,
    fontWeight: 600,
    lineHeight: 1.2,
    px: 1.25,
    py: 0.5,
    whiteSpace: "nowrap",
  },
  refer: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.75,
    textTransform: "none",
    color: "#1F5040",
    fontSize: 13,
    fontWeight: 500,
    px: 1,
    "&:hover": {
      color: "#0E3A2A",
      backgroundColor: "transparent",
    },
  },
  icon: {
    color: "green.dark",
  },
  menuBarIcon: { color: "green.dark", fontSize: 16 },
  iconButton: { ml: 1, mr: 0, color: "green.dark", fontSize: 12 },
  bell: { color: "green.dark", fontSize: 18 },
  totalMessages: { color: grey[500] },
  sent: { color: "primary.main" },
  emailLeft: { fontSize: 10, color: grey[400], textTransform: "none" },
  emailsButton: { display: "block", textAlign: "center" },
  topBarLogo: { width: 50, mr: 1, cursor: "pointer" },
  name: {
    px: 2,
    pb: 1,
    fontSize: { xs: 12, md: 14 },
    color: "green.dark",
    fontWeight: "bold",
  },
  email: {
    px: 2,
    fontSize: { xs: 10, md: 12 },
    color: grey[500],
    pb: 0.5,
  },
};

export default styles;
